<div class="grow-search-input-wrapper" [class.is-expanded]="isExpanded">
    <div class="autocomplete-container" fxlayout="row" fxLayoutAlign="space-between center">
        <label for="search" class="mr-8 search-label absolute !top-[14px] !left-[24px]">
            <mat-icon class="secondary-text icon-18">search</mat-icon>
        </label>
        <input
            #searchInputElement
            (focus)="onFocus()"
            (blur)="onBlur()"
            type="search"
            [placeholder]="'COURSE_CATALOG.LABEL.SEARCH_CATALOG' | translate"
            attr.aria-label="{{ 'COURSE_CATALOG.LABEL.SEARCH_CATALOG' | translate }}"
            autocomplete="off"
            [formControl]="searchInput"
            (keyup.enter)="search(searchInput.value)"
        />
        <button
            mat-icon-button
            class="clear-icon"
            (click)="search('')"
            *ngIf="searchInput.value"
            attr.aria-label="{{ 'GENERAL.BUTTON.CLOSE' | translate }} {{ 'GENERAL.LABEL.ARIA_ACTION' | translate }}"
        >
            <mat-icon>close</mat-icon>
        </button>

        <div
            class="autocomplete-items mat-elevation-z2"
            *ngIf="isDropdownVisible && ((searchInput.value && suggestedSearchPostings.length) || (!searchInput.value && (lastSearches.length || recentlyViewedPostings.length)))"
        >
            <ng-container *ngIf="!searchInput.value; else showSuggested">
                <div
                    fxlayout="row"
                    fxLayoutAlign="flex-start space-between"
                    class="autocomplete-item"
                    (click)="search(lastSearch); $event.stopPropagation()"
                    *ngFor="let lastSearch of lastSearches; let i = index"
                >
                    <div class="w-100-p" fxlayout="row" fxLayoutAlign="flex-start center">
                        <mat-icon attr.aria-label="{{ 'GENERAL.LABEL.RESTORE' | translate }}" class="mr-12">restore</mat-icon>
                        <span>{{ lastSearch }}</span>
                    </div>
                    <mat-icon
                        class="remove-autocomplete-item"
                        attr.aria-label="{{ 'GENERAL.BUTTON.CLOSE' | translate }} {{ 'GENERAL.LABEL.ARIA_ACTION' | translate }}"
                        (mousedown)="removeLastSearch(lastSearch, $event); $event.stopPropagation()"
                        >close</mat-icon
                    >
                </div>
                <div *ngIf="recentlyViewedPostings.length">
                    <div class="search-card-wrapper mt-12">
                        <div *ngFor="let postingResource of recentlyViewedPostings" class="search-card" (click)="navigateTo(postingResource); $event.stopPropagation()">
                            <div class="search-card-image" [style.background-image]="'url(' + postingResource.image.smallUrl + ')'"></div>

                            <div class="search-card-content">
                                <span class="search-card-type">
                                    {{ postingResource.postingType.displayNameKeySingular | translate }}
                                </span>
                                <h3 class="search-card-title my-0 text-truncate font-medium" tabindex="0">
                                    {{ postingResource.translation.title | translate }}
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-template #showSuggested>
                <div *ngIf="suggestedSearchPostings.length">
                    <div class="search-card-wrapper">
                        <div
                            *ngFor="let postingResource of suggestedSearchPostings"
                            class="search-card"
                            (click)="navigateTo(postingResource); $event.stopPropagation()"
                        >
                            <div class="search-card-image" [style.background-image]="'url(' + postingResource.image.smallUrl + ')'"></div>

                            <div class="search-card-content">
                                <span class="search-card-type">
                                    {{ postingResource.postingType.displayNameKeySingular | translate }}
                                </span>
                                <h3
                                    class="search-card-title my-0 text-truncate"
                                    tabindex="0"
                                    [innerHTML]="highlightMatch(postingResource.translation.title, searchInput.value)"
                                ></h3>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</div>
